import axios from 'axios'
import {networkCodes} from '../config/networkCodes'
import {store} from '../store/store'
import {userSlice} from '../store/user/userSlice'
// process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';

let isUpdatePromise = null

let lastAuthTokens = null

function updateToken(refreshToken) {
  return isUpdatePromise = new Promise(async res => {
    try {
      const response = await axios({
        url: (process.env.REACT_APP_API_URI ? process.env.REACT_APP_API_URI : "/") + '/token/refresh/',
        method: 'POST',
        data: {refresh: refreshToken}
      })
      const {access, refresh} = response.data
      localStorage.setItem('tokens', JSON.stringify({access, refresh}))
      res(response.data)
    } catch (e) {
      store.dispatch(userSlice.actions.logout())
      res()
    }
    isUpdatePromise = null
  })
}

function readStoredTokens() {
  try {
    return JSON.parse(localStorage.getItem('tokens') || 'null')
  } catch (e) {
    return null
  }
}

const getAccessToken = () => lastAuthTokens?.access ?? readStoredTokens()?.access ?? null
const getRefreshToken = () => lastAuthTokens?.refresh ?? readStoredTokens()?.refresh ?? null

function axiosUpdate(token, refresh) {
  lastAuthTokens = (token && refresh) ? {access: token, refresh} : null
  return appAxios
}

const appAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URI ? process.env.REACT_APP_API_URI : "/",
  headers: {
    'Accept-Language': 'ru',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
})

appAxios.interceptors.request.use((config) => {
  if (!config.headers?.Authorization) {
    const access = getAccessToken()
    if (access) {
      config.headers = config.headers || {}
      config.headers['Authorization'] = `Bearer ${access}`
    }
  }
  return config
})

// Если отправляем FormData, нельзя держать дефолтный Content-Type application/json:
// axios сам выставит корректный multipart/form-data с boundary.
appAxios.interceptors.request.use((config) => {
  const data = config?.data
  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    if (config.headers) {
      delete config.headers['Content-Type']
      delete config.headers['content-type']
    }
  }
  return config
})

appAxios.interceptors.response.use(null, async error => {
  let errorData = error.response?.data
  if (typeof Blob !== 'undefined' && errorData instanceof Blob && errorData.type.includes('json')) {
    try {
      errorData = JSON.parse(await errorData.text())
      error.response.data = errorData
    } catch (e) {
      // Keep non-JSON/malformed responses unchanged for normal error handling.
    }
  }
  const status = error.response?.status

  if (status === 401 && errorData?.code === networkCodes?.passwordChanged) {
    store.dispatch(userSlice.actions.logout())
    return Promise.reject(error)
  }

  // Обновляем токен по стандартному сценарию, если:
  // 1) получили 401 (как раньше), либо
  // 2) сервер на любой ответ вернул, что учётные данные не были предоставлены
  //    / access-токен невалиден (code === "token_not_valid").
  const shouldRefresh = status === 401
    || errorData?.detail === 'Учетные данные не были предоставлены.'
    || errorData?.code === networkCodes?.tokenNotValid

  const refreshToken = getRefreshToken()

  if (shouldRefresh && refreshToken && !error.config?.__isRetryAfterRefresh) {
    const tokens = isUpdatePromise ? await isUpdatePromise : await updateToken(refreshToken)

    if (!tokens) {
      store.dispatch(userSlice.actions.logout())
      return Promise.reject(error)
    }
    axiosUpdate(tokens.access, tokens.refresh)

    error.config.headers['Authorization'] = `Bearer ${tokens.access}`
    error.config.__isRetryAfterRefresh = true

    return appAxios.request(error.config)
  }

  return Promise.reject(error)
})

const network = {
  axios: appAxios,
  axiosUpdate,
  getLastAuthTokens: () => lastAuthTokens,
  navigate: () => console.log('navigate fail'),
}

export {network}
